import { logger as KVLogger, setLogTransports, ConsoleLogTransport, } from 'kv-logger';
import { getContextParams } from '../config';
import { addListener } from '../event';
import { APILogTransport } from './apiLogTransport';
import { withFilter } from './filterFactory';
import { formatError } from './format';
import { SentryLogTransport, SentryEventLogTransport } from './sentryLogTransport';
export { formatError } from './format';
const config = {
    console: true,
    consoleFilter: {},
    api: false,
    apiFilter: {},
    sentry: false,
    sentryFilter: {},
};
// handle context update
const contextTransports = [];
function updateContext(context) {
    contextTransports.forEach((t) => t.updateContext(context));
}
// init context params
addListener('contextParamsChanged', (params) => {
    updateContext(params);
});
/**
 * set the log config
 * @param options log config
 */
export function setLogConfig(options) {
    Object.assign(config, options);
    // config transports
    contextTransports.length = 0;
    const transports = [];
    if (config.console) {
        transports.push(withFilter(config.consoleFilter)(new ConsoleLogTransport('text')));
    }
    if (config.api) {
        const apiTransport = new APILogTransport();
        contextTransports.push(apiTransport);
        transports.push(withFilter(config.apiFilter)(apiTransport));
    }
    if (config.sentry) {
        const sentryTransport = new SentryLogTransport();
        contextTransports.push(sentryTransport);
        transports.push(sentryTransport);
        const sentryEventTransport = new SentryEventLogTransport();
        transports.push(withFilter(config.sentryFilter)(sentryEventTransport));
    }
    setLogTransports(transports);
    // init context params after transports are set
    updateContext(getContextParams());
}
/**
 * logger interface
 */
export const logger = {
    /**
     * report a log, should use info/warn/error instead, leave it here for handle logs in react-native jsbridge
     * @param level
     * @param msg
     * @param category
     */
    log(level, msg, category, params = {}) {
        KVLogger.log(level, msg, Object.assign(Object.assign({}, params), { category }));
    },
    /**
     * report an exception
     * @param error
     * @param category
     * @param params
     */
    exception(error, category = 'exception', params = undefined) {
        this.log('error', formatError(error), category, params);
        contextTransports.forEach((t) => t.exception && t.exception(error));
    },
    /**
     * report an error log
     * @param {*} msg
     * @param {*} category
     */
    error(msg, category, params) {
        this.log('error', msg, category, params);
    },
    /**
     * report a warning log
     * @param {*} msg
     * @param {*} category
     */
    warn(msg, category, params) {
        this.log('warn', msg, category, params);
    },
    /**
     * report a info log
     * @param msg
     * @param category
     * @param params
     */
    info(msg, category, params) {
        this.log('info', msg, category, params);
    },
    /**
     * report a debug log
     * @param msg
     * @param category
     * @param params
     */
    debug(msg, category, params) {
        this.log('debug', msg, category, params);
    },
};
export function getLogMethod(level, category) {
    return (msg) => {
        logger.log(level, msg, category);
    };
}
